export default {
	mounted() {
		if (window.top !== window.self) {
			console.warn('Clickjacking attempt detected!')
			window.top.location = window.self.location
			// try {
			// 	parent.location.replace(window.location.href)
			// } catch (e) {
			// 	window.open(window.location.href, "_top")
			// }
		}
	}
}